import AuthenticatedUser, { Language } from './AuthenticatedUser';
import AuthenticatedUserCustomer from './AuthenticatedUserCustomer';

export interface RawAuthenticatedUser {
	id: string;
	email: string;
	name: string;
	language: Language;
	customer: {
		id: string;
		name: string;
	};
}

export default function mapAuthenticatedUser(user: RawAuthenticatedUser): AuthenticatedUser {
	return new AuthenticatedUser(
		user.id,
		user.email,
		user.name,
		user.language,
		new AuthenticatedUserCustomer(user.customer.id, user.customer.name)
	);
}
